import { ProjectsService } from 'app/model/services/api-services/projects.service';
import { ProjectConfig } from './../../../types/project-config';
import { ProjectConfigUtil, ConfigOptions } from './../../../model/project-config-util';
import { ModalMessagerService } from './../modal-messager/modal-messager.service';
import { DictHandler } from './../../../types/handlers';
import { ProjectLoadDialogService } from './project-load-dialog.service';
import { SubscriptionMgr } from './../../../model/SubscriptionMgr';
import { NgbModal, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { IO } from 'app/model/IO';
import { Project } from 'app/model/project';
import { IfStmt } from '@angular/compiler';


export type ProjectHandler = (project: Project) => void;

export type ProjectLoadParams = {
  handler: ProjectHandler;
  projectConfig?: ProjectConfig;
  project?: Project;
}

@Component({
  selector: 'app-project-load-entry',
  templateUrl: './project-load-entry.component.html',
  styleUrls: ['./project-load-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectLoadEntryComponent implements OnInit {
  private handler?: ProjectHandler;
  private projectConfig?: ProjectConfig;
  private project?: Project;
  public importGeneral = true;
  public importAtts = true;
  public importPresets = true;
  public importSupplemental = true;
  constructor(public modal: NgbActiveModal, private projects: ProjectsService, private messager: ModalMessagerService, private cdr: ChangeDetectorRef) { }
  ngOnInit(): void {
  }
  Show(params: ProjectLoadParams) {
    this.handler = params.handler;
    if (params.project) {
      this.project = params.project;
    }
    if (params.projectConfig) {
      this.projectConfig = params.projectConfig;
    }
  }
  Hide() {
    this.modal.close();
  }
  LoadContent() {
    this.cdr.detectChanges();
    this.messager.RequestImport({ acceptedExtentions: ['rccfg', 'txt', 'zip'], readType: 'dataURL' },
      'Select a file to open', (result: any) => {
        if (!!this.handler) {
          const util: ProjectConfigUtil = new ProjectConfigUtil();
          const params: ConfigOptions = {
            attributes: this.importAtts,
            presets: this.importPresets,
            supplemental: this.importSupplemental,
            config: this.projectConfig
          }
          const config: ProjectConfig = util.FromRCCFG(IO.ReadSavedData(result.contents, true), params);
          const project: Project = new Project();
          project.SetProjectConfig(config);
          this.handler(project);
          this.Hide();
        }
      });
  }
  LoadProject() {
    if (!this.project) return;
    if (!this.project.projInfo) return;
    this.cdr.detectChanges();
    this.messager.Progress('Loading project from server', false, 50, 'Loading');
    this.projects.GetProject(Number(this.project.projInfo.project_id)).then((response) => {
      if (!this.project) return;
      if (response.project) {
        const config = response.project?.project_config.config;
        if (!config) return;
        const newConfig: any = {};
        if(this.importGeneral) {
          newConfig.general = config.general;
        } else {
          newConfig.general = this.project.config?.general;
        }
        if (this.importAtts) {
          if (!!config.attributes) {
            newConfig.attributes = config.attributes;
            if (!this.importSupplemental) {
              if (this.project.config?.attributes.suppl) {
                newConfig.suppl = this.project?.config.attributes.suppl
              } else {
                newConfig.suppl = [];
              }
            }
          }

        } else {
          newConfig.attributes = this.project.config?.attributes;
        }
        if (this.importPresets) {
          if (!!config.presets) {
            newConfig.presets = config.presets;
          }
        } else {
          newConfig.presets = this.project.config?.presets;
        }
        if (!!this.project.projInfo) {
          this.project.projInfo.project_config.config = newConfig;
        }
        this.project.SetProjectConfig(newConfig);
        if (!!this.handler) {
          this.handler(this.project!);
        }
        this.Hide();
        this.messager.Progress('Project Loaded', true, 100, 'Loading');

      }
    });

  }
  UpdateCB(which: EventTarget | null) {
    if (!which) return;
    const id = (which as HTMLInputElement).getAttribute('id');
    const checked = (which as HTMLInputElement).checked;
    switch (id?.split('_').shift()) {
      case 'general':
        this.importGeneral = checked;
        break;
      case 'attributes':
        this.importAtts = checked;
        break;
      case 'presets':
        this.importPresets = checked;
        break;
      case 'suppl':
        this.importSupplemental = checked;
        break;
    }
    this.cdr.detectChanges();
  }

}


@Component({
  selector: 'app-project-load-dialog',
  template: ''
})
export class ProjectLoadDialogComponent implements OnDestroy {
  modalRef?: NgbModalRef;
  subscriptionMgr: SubscriptionMgr = new SubscriptionMgr();
  lastTitle: string | null = null;
  constructor(private modalService: NgbModal, private service: ProjectLoadDialogService) {
    this.subscriptionMgr.Subscribe(this.service.requests, (params: ProjectLoadParams) => {
      this.modalRef = this.modalService.open(ProjectLoadEntryComponent, { backdrop: 'static' });
      (this.modalRef.componentInstance as ProjectLoadEntryComponent).Show(params);
    });
  }
  ngOnDestroy() {
    this.subscriptionMgr.CancelSubscriptions();
  }

}
